<template>
  <div>
    <!-- <b-card> -->
    <b-row>
      <b-col>
        <b-form-group label="시설명" label-for="_facilityName">
          <b-form-input v-model="record.facilityName" id="_facilityName" placeholder="시설명을 입력하세요."
            :disabled="isSuccess">
          </b-form-input>
        </b-form-group>
        <b-form-group label="시설유형" label-for="Facility type">
          <b-form-select id="Facility type" v-model="record.facilityType" :options="facilityTypes"
            :disabled="isSuccess">
            <template #first>
              <b-form-select-option :value="null" disabled>시설유형을 선택하세요.</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
        <b-form-group label="Company prefix" label-for="Company prefix">
          <b-form-select id="Company prefix" v-model="prefix" :options="companyPrefixies" @change="onChange"
            :disabled="updateMode">
            <template #first>
              <b-form-select-option :value="null" disabled>Please select a company prefix</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
        <b-form-radio-group class="text-right" v-model="record.facilityIdType" :options="facilityIdTypes"
          :disabled="updateMode">
        </b-form-radio-group>
        <b-form-group label="시설 ID" label-for="Facility ID">
          <b-form-input v-model="record.facilityId" id="Facility ID" placeholder="시설 ID번호를 입력하세요."
            :disabled="updateMode">
          </b-form-input>
          <b-form-invalid-feedback :state="prefixVaildation">
            입력한 KFT Food Trust ID는 조직의 접두사인 "{{prefix}}"가 포함되어 있지 않습니다.
          </b-form-invalid-feedback>
          <b-form-invalid-feedback :state="gs1Checkdigit">
              GS1 형식의 숫자가 아닙니다.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-button-group class="text-right mb-2" v-if="record.facilityIdType == 'KFT'">
          <b-button v-if="!updateMode && !isSuccess" @click="createId" squared style="border:0rem"
            variant="outline-primary">KFT
            Food Trust™ 시설식별자 등록</b-button>
        </b-button-group>

        <b-form-group label="Street address (optional)" label-for="Street address">
          <b-form-input v-model="record.streetAddress" id="Street address" placeholder="상세 주소를 입력하세요."
            :disabled="isSuccess">
          </b-form-input>
        </b-form-group>

        <b-row>
          <b-col lg="6">
            <b-form-group label="City (optional)" label-for="City">
              <b-form-input v-model="record.city" id="City" placeholder="시/도를 입력하세요." :disabled="isSuccess">
              </b-form-input>
            </b-form-group>
            <b-form-group label="Postal code (optional)" label-for="Postal code">
              <b-form-input v-model="record.postalCode" id="City" placeholder="우편번호를 입력하세요." :disabled="isSuccess">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group label="State or province (optional)" label-for="State or province">
              <b-form-input v-model="record.state" id="City" placeholder="주 또는 지방을 입력하세요." :disabled="isSuccess">
              </b-form-input>
            </b-form-group>
            <b-form-group label="Country or region (optional)" label-for="Country or region">
              <b-form-select id="Country or region" v-model="record.country" :options="regions" :disabled="isSuccess">
                <template #first>
                  <b-form-select-option :value="null" disabled>국가 또는 지역을 선택하세요.</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <h6 class="mb-3 mt-3"><b>GPS coordinates (optional)</b></h6>
        <b-row>
          <b-col lg="6">
            <b-form-group label="Latitude" label-for="Latitude">
              <b-form-input v-model="record.gpsX" id="Latitude" placeholder="WGS84 위도좌표" :disabled="isSuccess">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group label="Longitude" label-for="Longitude">
              <b-form-input v-model="record.gpsY" id="Longitude" placeholder="WGS84 경도좌표" :disabled="isSuccess">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <p></p>
        <b-button-group>
          <b-button v-if="isSuccess" style="width:200px" squared variant="dark" @click="goBack">
            Back to registered facilitys
          </b-button>
          <b-button v-if="!isSuccess" style="width:150px" squared :variant="`${!actionButtonShow ? '': 'dark'}`"
            :disabled="!actionButtonShow" @click="onSubmit">
            <b-icon v-if="actionButtonShow" icon="circle-fill" animation="throb"></b-icon>
            {{updateMode? 'Update' : 'Submit'}}
          </b-button>
          <b-button v-if="isNextInsert" style="width:200px" squared variant="primary" @click="clean">
            <!-- 다른시설등록 -->
            Register another facility
          </b-button>
        </b-button-group>
      </b-col>
      <b-col class="text-right">
        <b-link @click="onClosed">
          <b-icon icon="x" scale="3"></b-icon>
        </b-link>
        <b-card v-if="!updateMode" class="text-left mt-2">
          <b-card-text>
            <h6><b>Company prefix란?</b></h6>
            등록된 모든 시설은 올바른 회사 접두사로 시작됩니다. 회사에 여러 개의 접두사가 있는 경우, 이 시설의 접두사를 표시하세요.
          </b-card-text>
          <b-card-text v-if="record.facilityIdType == 'KFT'">
            <h6><b>KFT Food Trust 시설 ID란?</b></h6>
            GS-1이 아닌 시설을 등록하려면, 조직 내에서 친숙한 시설 참조 번호를 사용하세요. 예를 들어, XY123을 입력하면 KFT Food Trust는 회사 접두사와 결합하여 고유한 시설 ID를
            생성합니다.
          </b-card-text>
          <b-card-text v-if="record.facilityIdType == 'GS1'">
            <h6><b>GS-1 GLN은?</b></h6>
            고객님의 회사는 등록된 GS-1 조직이기 때문에, 당신의 시설도 GS-1에 등록되었을 가능성이 높습니다. 여기에 GS-1 Global location number(GLN)를 입력하십시오.
            KFT Food Trust는 시설을 참조하기 위해 이 번호를 사용합니다.
          </b-card-text>
        </b-card>

        <b-tabs v-else active-nav-item-class="font-weight-bold text-primary">
          <b-tab title="Facility details" class="text-left">
            <h6><b>Note</b></h6>
            Once a facility is registered, only the facility name can be edited.
          </b-tab>
          <b-tab class="text-left" title="IT data view (XML)">
            <h6><b>XML description</b></h6>
            {{formatXml}}
          </b-tab>
        </b-tabs>

      </b-col>
    </b-row>
    <!-- </b-card> -->
  </div>
</template>

<script>

import hal from 'hateoas-hal-link-resolver'
import xmlFormatter from 'xml-formatter';

export default {
  props: {
    record: {
      type: Object
    },
    company: {
      type: Object
    },
    updateMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },

  async beforeMount() {
    this.prefix = this.company.organizationPrefix
    if (this.record.facilityIdType = 'KFT') {
      this.facilityIdTypes[0].disabled = true;
    } else {
      this.facilityIdTypes[1].disabled = true;
    }
    this.setHttpComboData();
  },
  data() {
    return {
      actionButtonShow: false,
      prefix: '',
      isSuccess: false,
      isNextInsert: false,
      regions: [],
      facilityTypes: []
    }
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault();
      const fnc = this.updateMode ? this.update : this.insert;
      await fnc();
    },

    async insert() {
      const p = await this.$profile();
      const url = hal(await this.$profile(), 'facility');
      const organization = hal(this.company, 'self');
      const params = Object.assign({ organization: organization }, this.record);
      try {
        await this.$http.post(url, params);
        this.makeToast('success', `Facility ID ${params.facilityId} is registered to KFT Food Trust - ${params.facilityName}`);
        this.updateMode = true;
        this.isSuccess = true;
        this.isNextInsert = true;
      } catch (err) {
        alert(err)
      }
    },

    async update() {
      try {
        const url = hal(this.record, 'facility');
        await this.$http.patch(url, this.record);
        // console.log(response);
        this.makeToast('success', `${this.record.facilityName} is updated`);
        this.isSuccess = true;

      } catch (err) {
        alert(err);
      }
    },

    clean() {
      this.isSuccess = false;
      this.updateMode = false;
      this.isNextInsert = false;
      this.reset();
    },

    goBack(event) {
      event.preventDefault();
      // this.onClosed(event);
      this.$emit('OnRefresh')
      this.$nextTick(() => {
        // console.log('goBack')
        this.onClosed(event)
      });

    },

    onClosed(event) {
      // console.log(event)
      event.preventDefault();
      if (this.isSuccess) {
        this.$emit('OnRefresh');
      }
      this.$emit('OnClosed');
      this.$nextTick(() => {
        // console.log('onClosed')
        this.reset();
      })
    },

    reset() {
      this.record.facilityId = null
      this.record.facilityName = null
      this.record.facilityType = null
      this.record.facilityIdType = 'KFT'//GS1 OR KFT
      this.record.streetAddress = null
      this.record.city = null
      this.record.state = null
      this.record.postalCode = null
      this.record.country = null
      this.record.gpsX = null//for wgs84
      this.record.gpsY = null//for wgs84
    },

    onChange(val) {
      if ('other_prefix' == val) {
        this.facilityIdTypes[0].disabled = false;
        this.facilityIdTypes[1].disabled = true;
        this.record.facilityIdType = 'GS1'
        this.record.facilityId = ''
      } else {
        this.facilityIdTypes[0].disabled = true;
        this.facilityIdTypes[1].disabled = false;
        this.record.facilityIdType = 'KFT'
      }
    },


    async setHttpComboData() {
      try {
        let response = await this.$http.get('code/regions');
        this.regions = response.data;
        response = await this.$http.get('code/facilityTypes');
        this.facilityTypes = response.data;
      } catch (err) {
        console.log(err)
      }
    },

    createId() {
      this.record.facilityId = this.company.organizationPrefix.concat('.', Math.random().toString(36).substring(2, 8));
    },

    changeState() {
      this.actionButtonShow = this.updateMode ? true : this.record.facilityName && this.record.facilityType && this.record.facilityId;
    },

    makeToast(variant, message) {
      this.$bvToast.toast(message, {
        title: `200 OK`,
        variant: variant,
        solid: true
      })
    },
    checkdigit(input) {
      let array = input.split('').reverse();

      let total = 0;
      let i = 1;
      array.forEach(number => {
        number = parseInt(number);
        if (i % 2 === 0) {
          total = total + number;
        }
        else {
          total = total + (number * 3);
        }
        i++;
      });
      return (Math.ceil(total / 10) * 10) - total;
    },
    //서버에서 받아오도록
    epcisCBV() {
      return `
<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<ns3:itemDataNotificationMessage
    xmlns:ns6="urn:gs1:ecom:despatch_advice:xsd:3"
    xmlns:ns5="urn:gs1:ecom:order:xsd:3"
    xmlns:ns7="urn:gs1:ecom:receiving_advice:xsd:3"
    xmlns:ns2="http://www.unece.org/cefact/namespaces/StandardBusinessDocumentHeader"
    xmlns:ns4="urn:gs1:gdsn:basic_party_registration:xsd:3"
    xmlns:ns3="urn:gs1:ecom:item_data_notification:xsd:3">
    <ns2:StandardBusinessDocumentHeader>
        <ns2:HeaderVersion>1.0</ns2:HeaderVersion>
        <ns2:Sender>
            <ns2:Identifier Authority="GS1"/>
        </ns2:Sender>
        <ns2:Receiver>
            <ns2:Identifier Authority="GS1"/>
        </ns2:Receiver>
        <ns2:DocumentIdentification>
            <ns2:Standard>GS1</ns2:Standard>
            <ns2:TypeVersion>3.3</ns2:TypeVersion>
            <ns2:InstanceIdentifier>${hal(this.record, 'self')}</ns2:InstanceIdentifier>
            <ns2:Type>itemDataNotification</ns2:Type>
            <ns2:MultipleType>false</ns2:MultipleType>
            <ns2:CreationDateAndTime>${this.record.createdDt}</ns2:CreationDateAndTime>
        </ns2:DocumentIdentification>
    </ns2:StandardBusinessDocumentHeader>
    <tradeItemData>
        <tradeItemDescription languageCode="en">${this.record.facilityName}</tradeItemDescription>
        <gtin>urn:yysoft:kft:facility:class:${this.record.facilityId}</gtin>
        <sku>7b3bca1a98c46f69ff4d39e24b76aa55</sku>
        <dataSource>
            <gln>urn:yysoft:kft:location:loc:4293490043069.hq</gln>
        </dataSource>
        <dataRecipient/>
    </tradeItemData>
</ns3:itemDataNotificationMessage>`
    },
  },

  watch: {
    record: {
      deep: 'updateMode',
      handler: 'changeState'
    },
  },
  computed: {
    facilityIdTypes() {
      const facilityIdTypes = [];
      facilityIdTypes.push({ text: 'GS1', value: 'GS1', disabled: false })
      facilityIdTypes.push({ text: 'KFT Food Trust™', value: 'KFT', disabled: false })
      return facilityIdTypes;
    },
    companyPrefixies() {
      const companyPrefixies = [];
      companyPrefixies.push({ text: this.company.organizationPrefix, value: this.company.organizationPrefix })
      companyPrefixies.push({ text: 'Register a facility with another prefix', value: 'other_prefix' })
      return companyPrefixies;
    },
    formatXml() {
      return xmlFormatter(this.epcisCBV());
    },
    prefixVaildation() {      
      if (this.record.facilityId && this.record.facilityIdType == 'KFT') return this.record.facilityId.startsWith(this.prefix)
      return true;
    },
    gs1Checkdigit(){
      if(this.record.facilityId && this.record.facilityIdType == 'GS1' && this.record.facilityId.length > 7) {
        return parseInt(this.record.facilityId.slice(0, 1)) == this.checkdigit(this.record.facilityId )
      }
      return true;
    }
  }
}
</script>